export const SCROLL_TOP_POSITION = 0;
